module.exports = __webpack_public_path__ + "img/Frame.ad7dc1d9.png";